import { graphqlPost } from '@/libs/tpm-analytics/graphql/transport';
import { TargetRecord } from '@/libs/tpm-analytics/core/types';

/**
 * Repository for OEE target thresholds (world class and tenant targets).
 */
export class TargetsRepository {
    static async fetchTargets(): Promise<TargetRecord[]> {
        try {
            const query = `query { targets(pageSize: 999999) { id fromDate toDate worldClassOee targetOee targetOeeAvailability targetOeePerformance targetOeeQuality workplaceId locationId } }`;
            const data = await graphqlPost<any>(query, {});
            const list = data?.targets ?? [];
            return Array.isArray(list) ? (list as TargetRecord[]) : [];
        } catch {
            return [];
        }
    }
}


